import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import InterestEditor from './InterestEditor';

function NewInterestNew() {
	const { id } = useParams();
	const navigate = useNavigate();
	const debtPath = `/AdminScreen/debts/debt/${id}/detalles`;

	return (
		<EntityList>
			<Helmet>
				<title>Agregar Interes</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Deudas', to: '/AdminScreen/debts' },
					{ label: 'Deuda', to: `/AdminScreen/debts/debt/${id}` },
					{ label: 'Agregar Interes' },
				]}
				title='Agregar Interes'
				subtitle='Completá los datos para registrar el interés de esta deuda.'
			/>
			<InterestEditor
				mode='create'
				lockedDebtId={id}
				onCancel={() => navigate(debtPath)}
				onSaved={() => navigate(debtPath)}
				saveLabel='Agregar'
			/>
		</EntityList>
	);
}

export default NewInterestNew;
